import { DatePicker } from 'antd'
import { KTIcon } from '../../../_metronic/helpers'
import { useLayout } from '../../../_metronic/layout/core'

export default function ManageTemplateToolbar() {
  const { RangePicker } = DatePicker
  const {
    setManageTemplateDateFilter,
    manageTemplatePeidFilter,
    setManageTemplatePeidFilter,
    setSearchQuery,
    searchQuery,
    statusFilter, setStatusFilter
  } = useLayout()

  return (
    <div className='d-flex align-items-center'>
      <RangePicker
        className='bg-secondary-custom border-0 text-white'
        style={{ height: '34px' }}
        onChange={(value, dateString) => setManageTemplateDateFilter(dateString)}
        disabledDate={(current) => {
          return current && current.valueOf() > Date.now();
        }}
      />
      <select
        className='form-select form-select-sm form-select-solid w-auto ms-2 bg-secondary-custom'
        onChange={(e) => setStatusFilter(e.target.value)}
        value={statusFilter}
      >
        <option value=''>All</option>
        <option value='disabled'>Disabled</option>
        <option value='enabled'>Enabled</option>
      </select>
      <div className='d-flex align-items-center position-relative my-1 ms-2'>
        <KTIcon iconName='magnifier' className='text-white-500 position-absolute ms-2' />
        <input
          type='text'
          id='kt_filter_search'
          className='form-control form-control-solid form-select-sm w-150px ps-9'
          placeholder='Search Template'
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <div className='d-flex align-items-center position-relative my-1 ms-2'>
        <KTIcon iconName='magnifier' className='text-white-500 position-absolute ms-2' />
        <input
          type='text'
          className='form-control form-control-solid form-select-sm w-150px ps-9'
          placeholder='Search PE ID'
          value={manageTemplatePeidFilter}
          onChange={(e) => setManageTemplatePeidFilter(e.target.value)}
        />
      </div>

      {manageTemplatePeidFilter ? (
        <button
          className='btn h-40px btn-danger ms-3 d-flex align-items-center'
          onClick={() => setManageTemplatePeidFilter('')}
        >
          Clear
          <KTIcon iconName='cross' className='text-white fs-1 ms-5' />
        </button>
      ) : (
        <></>
      )}
    </div>
  )
}
